import { render, staticRenderFns } from "./SearchPageCustom.vue?vue&type=template&id=798ec02b&"
import script from "./SearchPageCustom.vue?vue&type=script&lang=js&"
export * from "./SearchPageCustom.vue?vue&type=script&lang=js&"
import style0 from "./SearchPageCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports